import Vue from "vue"
import VueX from 'vuex'
import VueCookies from 'vue-cookies'

Vue.use(VueCookies)
Vue.use(VueX)

const global = {
	namespaced: true,

	state: {
		states: {
			MENU: 0,
			ONGOING_SESSION: 1,
			ONGOING_GAME: 2,
			WATCH_CARD: 3,
			ONGOING_QUESTIONS: 4
		},
		authenticated: false,
		profile: {
			datas: {}
		},
		appStep: 0,
		token: '',
		cookieConsent: false,
		kidsFilter: 0,
		auth0user: {},
		stars: 0,
		level_copper: 0,
		level_silver: 0,
		level_gold: 0,
		autoSpeech: 0,
		mute: false,
		showsData: {},
		seasonsData: {},
		seasonsIndex: [],
		dataLoaded: {
			topShow: false,
			basicShow: false,
			user: false,
			ongoing: false,
		},
		dataReload: 0,

		navOpened: true,

		closableCardOpened: false,
		carousselNav: {
			to: 1,
			transition: false
		},
		fullWordsLearnt: [],
		windowwidth: 0,
		windowheight: 0,
		isMobile: false,
	},

	mutations: {
		SET_isMobile(state, value) {
			state.isMobile = value;
		},
		SET_appStep(state, step) {
			state.appStep = step;
		},
		SET_token(state, value) {
			state.token = value;
		},
		SET_closableCardOpened(state, value) {
			state.closableCardOpened = value;
		},
		SET_carousselNavTo(state, value) {
			state.carousselNav.to = value;
		},
		SET_carousselNavTransition(state, value) {
			state.carousselNav.transition = value;
		},
		SET_authenticated(state, value) {
			state.authenticated = value;
		},
		SET_profile(state, value) {
			// On évite d'écraser l'attribut loaded
			Object.assign(state.profile, value)
		},
		SET_userDatas(state, value) {
			state.profile.datas = Object.assign({}, state.profile.datas, value)
		},
		UPDATE_userDatas(state, value) {
			state.profile.datas = Object.assign({}, state.profile.datas, value)
		},
		CHANGE_userData(state, property) {
			Vue.set(state.profile.datas, property.name, property.value)
		},
		SET_cookieConsent(state) {
			state.cookieConsent = true;
		},
		SET_kidsFilter(state, kidsFilter) {
			state.kidsFilter = kidsFilter;
		},
		SET_autoSpeech(state, autoSpeech) {
			state.autoSpeech = autoSpeech;
		},
		SET_mute(state, isMuted) {
			state.mute = isMuted;
		},
		SET_navOpened(state, isNavOpened) {
			state.navOpened = isNavOpened;
		},
		SET_catalogData(state, data) {
			// On ajoute un ordre d'origine à seasons_index pour pouvoir le retrouver après des sort()
			let temp = data['seasons_index'];

			for(let i = 0; i< temp.length; i++) {
				temp[i] = {
					id : temp[i],
					order : i
				}
			}

			state.seasonsIndex = temp;
			state.showsData = Object.assign({}, state.showsData, data['shows_data'])
			state.seasonsData = Object.assign({}, state.seasonsData, data['seasons_data'])
		},
		SET_showsData(state, data) {
			state.showsData = Object.assign({}, state.showsData, data)
		},
		SET_seasonsData(state, data) {
			state.seasonsData = Object.assign({}, state.seasonsData, data)
		},
		UPDATE_seasonsData(state, data) {
			state.seasonsData[data.id] = data.data;
		},
		UPDATE_showsData(state, data) {
			state.showsData[data.id] = data.data;
		},

		UPDATE_seasonsIndex(state, data) {
			state.seasonsIndex = data;
		},
		/*
		COMPLETE_apiData(state, data) {
			let temp = {}
			for(let show in data) {
				if(state.apiData[show] == undefined) {
					temp[show] = data[show];
				}
			}
			//state.apiData = Object.entries(state.apiData)
			state.apiData = new Map(
				Object.entries(state.apiData).sort(function(a, b) {
					return b[1].score - a[1].score
				})
			)
		},*/
		SET_apiDataKey(state, data) {
			state.apidata[data.key] = data.data;
		},
		SET_dataLoaded(state, data) {
			state.dataLoaded[data.name] = data.value;
		},
		SET_dataReload(state) {
			state.dataReload++
		},
		SET_level_copper(state, level_count) {
			state.level_copper = level_count;
		},
		SET_level_silver(state, level_count) {
			state.level_silver = level_count;
		},
		SET_level_gold(state, level_count) {
			state.level_gold = level_count;
		},
		SET_auth0user(state, data) {
			state.auth0user = data;
		},
		SET_fullWordsLearnt(state, value) {
			state.fullWordsLearnt = value;
		},
		SET_windowwidth(state, value) {
			state.windowwidth = value;
		},
		SET_windowheight(state, value) {
			state.windowheight = value;
		},
	},

	actions: {
		set_isMobile(context, value) {
			context.commit('SET_isMobile', value)
		},
		set_appStep(context, step) {
			if(step !== (state => state.appStep)) {
				context.commit('SET_appStep', step)
			}
		},
		set_token(context, value) {
			context.commit('SET_token', value)
		},
		set_closableCardOpened(context, value) {
			context.commit('SET_closableCardOpened', value)
		},
		set_carousselNavTo(context, value) {
			context.commit('SET_carousselNavTo', value)
		},
		set_carousselNavTransition(context, value) {
			context.commit('SET_carousselNavTransition', value)
		},
		set_authenticated(context, value) {
			context.commit('SET_authenticated', value)
		},
		set_profile(context, value) {
			context.commit('SET_profile', value)
		},
		set_userDatas(context, value) {
			context.commit('SET_userDatas', value)
		},
		update_userDatas(context, value) {
			context.commit('UPDATE_userDatas', value)
		},
		change_userData(context, value) {
			context.commit('CHANGE_userData', value)
		},
		set_cookieConsent(context) {
			context.commit('SET_cookieConsent')
		},
		set_kidsFilter(context, kidsFilter) {
			//Vue.$cookies.set('forKids', kidsFilter);
			context.commit('SET_kidsFilter', kidsFilter)
		},
		set_autoSpeech(context, value) {
			context.commit('SET_autoSpeech', value)
		},
		set_mute(context, value) {
			context.commit('SET_mute', value)
		},
		set_navOpened(context, value) {
			context.commit('SET_navOpened', value)
		},
		set_catalogData(context, catalogData) {
			context.commit('SET_catalogData', catalogData)
		},
		set_showsData(context, data) {
			context.commit('SET_showsData', data)
		},
		set_seasonsData(context, data) {
			context.commit('SET_seasonsData', data)
		},
		update_seasonsIndex(context, seasonsList) {
			context.commit('SET_seasonsIndex', seasonsList)
		},
		update_showsData(context, data) {
			context.commit('UPDATE_showsData', data)
		},
		update_seasonsData(context, data) {
			context.commit('UPDATE_seasonsData', data)
		},
		set_dataLoaded(context, data) {
			context.commit('SET_dataLoaded', data)
		},
		set_dataReload(context) {
			context.commit('SET_dataReload')
		},
		set_apiDataKey(context, data) {
			context.commit('SET_apiDataKey', data)
		},
		set_level_copper(context, level_count) {
			context.commit('SET_level_copper', level_count)
		},
		set_level_silver(context, level_count) {
			context.commit('SET_level_silver', level_count)
		},
		set_level_gold(context, level_count) {
			context.commit('SET_level_gold', level_count)
		},
		set_auth0user(context, data) {
			context.commit('SET_auth0user', data)
		},
		set_fullWordsLearnt(context, value) {
			context.commit('SET_fullWordsLearnt', value)
		},
		set_windowwidth(context, value) {
			context.commit('SET_windowwidth', value)
		},
		set_windowheight(context, value) {
			context.commit('SET_windowheight', value)
		},
	},

	getters: {
		routeParams: (state, getters, rootState) => rootState.route.params,
		routeName: (state, getters, rootState) => rootState.route.name,
		isMobile: state => state.isMobile,
		states: state => state.states,
		authenticated: state => state.authenticated,
		profile: state => {
        return {
            ...state.profile,
            datas: {
                ...state.profile.datas,
                is_premium: true // Override is_premium to always be true
            }
        };
    },
		appStep: state => state.appStep,
		token: state => state.token,
		cookieConsent: state => state.cookieConsent,
		kidsFilter: state => state.kidsFilter,
		level_copper: state => state.level_copper,
		level_silver: state => state.level_silver,
		level_gold: state => state.level_gold,
		autoSpeech: state => state.autoSpeech,
		mute: state => state.mute,
		navOpened: state => state.navOpened,
		showsData: state => state.showsData,
		seasonsData: state => state.seasonsData,
		seasonsIndex: state => state.seasonsIndex,
		dataLoaded: state => state.dataLoaded,
		dataReload: state => state.dataReload,
		closableCardOpened: state => state.closableCardOpened,
		auth0user: state => state.auth0user,
		carousselNav: state => state.carousselNav,
		fullWordsLearnt: state => state.fullWordsLearnt,
		windowwidth: state => state.windowwidth,
		windowheight: state => state.windowheight,
	}
}

const show = {
	namespaced: true,

	state: {
		currentSeason: {
			loaded: false
		},
		currentWordsLearnt: [],
		wordsLearntLoaded: false,
		currentShow: {},
		currentEpisodeIndex: 0,
		currentEpisodeData: {},
		seasonRequested:-1
	},

	mutations: {
		SET_currentShow(state, show) {
			state.currentShow = show;
		},
		SET_currentSeason(state, show) {
			state.currentSeason = show;
		},
		SET_currentWordsLearnt(state, words) {
			state.currentWordsLearnt = words;
		},
		UPDATE_currentWordLearnt(state, word) {
			state.currentWordsLearnt.forEach((element, index, array) => {
				if(element.id === word.id) {
					array[index] = word;
				}
			});
		},
		SET_wordsLearntLoaded(state, value) {
			state.wordsLearntLoaded = value;
		},
		SET_seasonRequested(state, value) {
			state.seasonRequested = value;
		},
		SET_currentSeasonLoaded(state, value) {
			state.currentSeason.loaded = value
			Vue.set(state.currentSeason, 'loaded', value);
		},
		SET_currentEpisodeData(state, epData) {
			state.currentEpisodeData = epData;
		},
		SET_currentEpisodeIndex(state, epIndex) {
			state.currentEpisodeIndex = epIndex;
		},
		ADD_currentEpisodeData(state, newProp) {
			Vue.set(state.currentEpisodeData, newProp.name, newProp.value)
		},
		CHANGE_currentEpisodeData(state, changedProp) {
			state.currentEpisodeData[changedProp.name] = changedProp.value;
		},
	},

	actions: {
		set_currentSeason(context, show) {
			context.commit('SET_currentSeason', show)
		},
		set_currentWordsLearnt(context, words) {
			context.commit('SET_currentWordsLearnt', words)
		},
		update_currentWordLearnt(context, word) {
				context.commit('UPDATE_currentWordLearnt', word)
		},
		set_wordsLearntLoaded(context, value) {
			context.commit('SET_wordsLearntLoaded', value)
		},
		set_seasonRequested(context, value) {
			context.commit('SET_seasonRequested', value)
		},
		set_currentShow(context, value) {
			context.commit('SET_currentShow', value)
		},
		set_currentSeasonLoaded(context, value=true) {
			context.commit('SET_currentSeasonLoaded', value)
		},
		set_currentEpisodeData(context, epData) {
			context.commit('SET_currentEpisodeData', epData)
		},
		set_currentEpisodeIndex(context, epIndex) {
			context.commit('SET_currentEpisodeIndex', epIndex)
		},
		add_currentEpisodeData(context, newProp) {
			context.commit('ADD_currentEpisodeData', newProp)
		},
		change_currentEpisodeData(context, changedProp) {
			context.commit('CHANGE_currentEpisodeData', changedProp)
		}
	},

	getters: {
		currentSeason: state => state.currentSeason,
		currentWordsLearnt: state => state.currentWordsLearnt,
		wordsLearntLoaded: state => state.wordsLearntLoaded,
		seasonRequested: state => state.seasonRequested,
		currentShow: state => state.currentShow,
		backgroundPath: state => state.currentShow.backgroundPath,
		currentEpisodeData: state => state.currentEpisodeData,
		currentEpisodeIndex: state => state.currentEpisodeIndex,
	}
}

let duration = 2.5;
if(location.origin === 'http://localhost:8080') {
	duration = 0.5
}

const blog = {
	namespaced: true,

	state: {
		currentArticle: {
			content: {},
			loaded: false
		},
		blogData: {},
		blogDataLoaded: false
	},

	mutations: {
		SET_currentArticle(state, value) {
			state.currentArticle.content = value.content;
			state.currentArticle.loaded = true;
		},
		SET_blogData(state, value) {
			state.blogData = value;
		},
		SET_blogDataLoaded(state, value) {
			state.blogDataLoaded = value;
		},
	},

	actions: {
		set_currentArticle(context, value) {
			context.commit('SET_currentArticle', value)
		},
		set_blogData(context, value) {
			context.commit('SET_blogData', value)
		},
		set_blogDataLoaded(context, value) {
			context.commit('SET_blogDataLoaded', value)
		},

	},

	getters: {
		currentArticle: state => state.currentArticle,
		blogData: state => state.blogData,
		blogDataLoaded: state => state.blogDataLoaded
	}
}

const session = {
	namespaced: true,

	state: {
		sessionWordsList: {
			vocab: [],
			loaded: false,
		},
		sessionType: 'episode',
		wordNum: 0,
		testNum: 0,
		testNumSerie: 0,
		currentComponent: "",
		vocabSessionNum: 0,
		currentWord: null,
		displayWord: false,
		learntWords: [],
		errorsNumber: 0,
		learntLemmasId: [],
		lemmasToRemoveIds: [],
		currentLevelCount: [],
		startDate: "",
		endSession: false,
		sessionFinished: 0,
		duration: {
			mainSession: duration,
			bonusSession: duration
		},
	},

	mutations: {
		SET_sessionWordsList(state, vocab) {
			state.sessionWordsList.vocab = vocab;
			state.sessionWordsList.loaded = true;
		},
		SET_sessionWordsListLoaded(state, value) {
			state.sessionWordsList.loaded = value;
		},
		SET_sessionType(state, value) {
			state.sessionType = value;
		},
		SET_wordNum(state, wordNum) {
			state.wordNum = wordNum;
		},
		SET_testNum(state, testNum) {
			state.testNum = testNum;
		},
		SET_testNumSerie(state, value) {
			state.testNumSerie = value;
		},
		SET_currentComponent(state, value) {
			state.currentComponent = value;
		},
		SET_vocabSessionNum(state, value) {
			state.vocabSessionNum = value;
		},
		SET_currentWord(state, value) {
			state.currentWord = value;
		},
		SET_displayWord(state, value) {
			state.displayWord = value;
		},
		ADD_learntWord(state, value) {
			state.learntWords.push(value);
		},
		INC_learntWord(state, id) {
			//On récupère l'index dans le tableau du mot à incrémenter.
			//On incrémente son attribut count puis on réinjecte dynamiquement le mot dans le tableau
			let indexId = state.learntWords.findIndex(element => element.id == id);
			let currentWord = state.learntWords[indexId];
			currentWord.lemmaCount++;
			//currentWord.lemma.count++;
			Vue.set(state.learntWords, indexId, currentWord);
		},
		ADD_learntLemmasId(state, value) {
			state.learntLemmasId.push(value);
		},
		ADD_lemmasToRemoveIds(state, value) {
			state.lemmasToRemoveIds.push(value);
		},
		RESET_learntWords(state) {
			state.learntWords = [];
		},
		RESET_learntLemmasId(state) {
			state.learntLemmasId = []
		},
		RESET_lemmasToRemoveIds(state) {
			state.lemmasToRemoveIds = []
		},
		SET_currentLevelCount(state, value) {
			state.currentLevelCount = value;
		},
		SET_endSession(state, value) {
			state.endSession = value;
		},
		SET_startDate(state, value) {
			state.startDate = value;
		},
		SET_errorsNumber(state, value) {
			state.errorsNumber = value;
		},
		SET_sessionFinished(state, value) {
			state.sessionFinished = value;
		},
	},

	actions: {
		set_sessionWordsList(context, value) {
			context.commit('SET_sessionWordsList', value)
		},
		set_sessionWordsListLoaded(context, value) {
			context.commit('SET_sessionWordsListLoaded', value)
		},
		set_sessionType(context, value) {
			context.commit('SET_sessionType', value)
		},
		set_wordNum(context, value) {
			context.commit('SET_wordNum', value)
		},
		set_testNum(context, value) {
			context.commit('SET_testNum', value)
		},
		set_testNumSerie(context, value) {
			context.commit('SET_testNumSerie', value)
		},
		set_currentComponent(context, value) {
			context.commit('SET_currentComponent', value)
		},
		set_vocabSessionNum(context, value) {
			context.commit('SET_vocabSessionNum', value)
		},
		set_currentWord(context, value) {
			context.commit('SET_currentWord', value)
		},
		set_displayWord(context, value) {
			context.commit('SET_displayWord', value)
		},
		add_learntWord(context, value) {
			context.commit('ADD_learntWord', value)
		},
		inc_learntWord(context, id) {
			context.commit('INC_learntWord', id)
		},
		add_learntLemmasId(context, value) {
			context.commit('ADD_learntLemmasId', value)
		},
		add_lemmasToRemoveIds(context, value) {
			context.commit('ADD_lemmasToRemoveIds', value)
		},
		reset_learntWords(context) {
			context.commit('RESET_learntWords')
		},
		reset_learntLemmasId(context) {
			context.commit('RESET_learntLemmasId')
		},
		reset_lemmasToRemoveIds(context) {
			context.commit('RESET_lemmasToRemoveIds')
		},
		set_currentLevelCount(context, value) {
			context.commit('SET_currentLevelCount', value)
		},
		set_endSession(context, value) {
			context.commit('SET_endSession', value)
		},
		set_startDate(context, value) {
			context.commit('SET_startDate', value)
		},
		set_errorsNumber(context, value) {
			context.commit('SET_errorsNumber', value)
		},
		set_sessionFinished(context, value) {
			context.commit('SET_sessionFinished', value)
		},
	},

	getters: {
		sessionWordsList: state => state.sessionWordsList,
		sessionType: state => state.sessionType,
		wordNum: state => state.wordNum,
		testNum: state => state.testNum,
		testNumSerie: state => state.testNumSerie,
		currentComponent: state => state.currentComponent,
		vocabSessionNum: state => state.vocabSessionNum,
		currentWord: state => state.currentWord,
		displayWord: state => state.displayWord,
		learntWords: state => state.learntWords,
		learntLemmasId: state => state.learntLemmasId,
		lemmasToRemoveIds: state => state.lemmasToRemoveIds,
		currentLevelCount: state => state.currentLevelCount,
		endSession: state => state.endSession,
		startDate: state => state.startDate,
		errorsNumber: state => state.errorsNumber,
		duration: state => state.duration,
		sessionFinished: state => state.sessionFinished
	},
}

const game = {
	namespaced: true,

	state: {
		gameOn: false,
		gameWordsList: {
			vocab: [],
			loaded: false
		},
		gameOrigin: ""
	},

	mutations: {
		SET_gameOn(state, value) {
			state.gameOn = value;
		},
		SET_gameWordsList(state, vocab) {
			state.gameWordsList.vocab = vocab;
		},
		SET_gameWordsListLoaded(state, value) {
			state.gameWordsList.loaded = value;
		},
		SET_gameOrigin(state, value) {
			state.gameOrigin = value;
		},

	},

	actions: {
		set_gameOn(context, value) {
			context.commit('SET_gameOn', value)
		},
		set_gameWordsList(context, value) {
			context.commit('SET_gameWordsList', value)
		},
		set_gameWordsListLoaded(context, value) {
			context.commit('SET_gameWordsListLoaded', value)
		},
		set_gameOrigin(context, value) {
			context.commit('SET_gameOrigin', value)
		},
	},

	getters: {
		gameOn: state => state.gameOn,
		gameWordsList: state => state.gameWordsList,
		gameOrigin: state => state.gameOrigin
	},
}

export const store = new VueX.Store({
	modules: {
		global: global,
		show: show,
		blog: blog,
		session: session,
		game: game
	}
});

export default store;
